__turbopack_context__.v({
  "containerList": "DiscoveryResult-module-scss-module__yUdXRq__containerList",
  "loadMoreButtonContainer": "DiscoveryResult-module-scss-module__yUdXRq__loadMoreButtonContainer",
  "tabs": "DiscoveryResult-module-scss-module__yUdXRq__tabs",
  "topicsContainer": "DiscoveryResult-module-scss-module__yUdXRq__topicsContainer",
});
